<template>
  <div>
    <nav-bar v-bind:statusAction="message"></nav-bar>
    <div class="wrap loginform">
      <div class="container">
        <div class="row vertical-center">
          <b-col md="8" offset-md="2">
            <ValidationObserver v-slot="{ handleSubmit }">
              <b-form
                @submit.prevent="handleSubmit(onSubmit)"
                data-vv-scope="login"
                class="login-form"
              >
                <b-row>
                  <b-col>
                    <a href="/" class="brand-main">
                      <img
                        id="logo-desk"
                        src="../../assets/logo.jpg"
                        alt="Movileuros Logo"
                        class="login-img"
                      />
                    </a>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <p class="mt-4">{{$t('verfication_title')}}</p>
                  </b-col>
                </b-row>

                <label>
                  <p class="label-txt">{{$t('verficaiton_desc')}}</p>

                  <ValidationProvider rules="required|min:6|max:6" v-slot="{ errors }">
                    <input
                      id="code"
                      type="number"
                      name="Verfication code"
                      class="input"
                      v-model="loginData.code"
                      autofocus
                      required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div class="line-box">
                    <div class="line"></div>
                  </div>
                </label>
                <b-row>
                  <b-col md="4">
                    <b-link v-show="!isLoading"  @click="sendCode">{{$t('not_code')}}</b-link>
                  </b-col>
                  <b-col md="4">
                    <b-spinner v-show="isLoading" variant="primary" type="grow" label="Spinning"></b-spinner>
                  </b-col>
                  <b-col md="4">
                    <button v-show="!isLoading" type="submit">{{$t('submit')}}</button>
                  </b-col>
                </b-row>
              </b-form>
            </ValidationObserver>
          </b-col>
        </div>
      </div>
    </div>

    <!--  -->

    <my-footer></my-footer>
  </div>
</template>
<script type="text/babel">
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { extend } from "vee-validate";
import { max, required, min } from "vee-validate/dist/rules";

//import { Role } from "../../helpers/role";
import Auth from "../../services/auth";
import NavBar from "./NavBar.vue";
import MyFooter from "./Footer.vue";

//import ResponseManager from '../../services/ResponseManager';

export default {
  components: {
    NavBar,
    MyFooter,
    ValidationProvider,
    ValidationObserver
  },

  created() {
    extend("max", max);
    extend("required", required);
    extend("min", min);
  },

  data() {
    return {
      loginData: {
        code: ""
      },
      ischangeLoading: false,
      message: {},
      isLoading: false
    };
  },

  methods: {
    onSubmit() {
      this.isLoading = true;
      Auth.check2FA(this.loginData).then(res => {
        this.isLoading = false;
        if (res.errorCode == 0) {
      
          Auth.set2FAVerfied(true);
          var menu = Auth.userData().menus[0];
          Auth.setEndPoint(menu);
          this.$router.push({
            name: "home",
            params: { id: menu.title, endpoint: menu.endpoint }
          });
        } else {
          this.message = res;
        }
      });
    },
    sendCode() {
      this.isLoading = true;
      Auth.send2FACode().then(res => {
        this.isLoading = false;
        if (res) {
          this.message = res;
        }
      });
    }
  }
};
</script>

